export default "__VITE_ASSET__DQiVA_Eo__"